module.exports = __webpack_public_path__ + "media/images/flags/la-d712c57a35f415198f32c2998e941ff0.svg";